import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from "./../../../_services/acmic.service";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'mapfre-card',
  templateUrl: './mapfre-card.component.html'
})
export class MapfreCardComponent implements OnInit {
  @Input() additionalClasses:             string;
  @Input() additionalSectionClasses:        string;
  @Input() additionalCardContentClasses:    string;
  @Input() singleCard = true;
  isAcmic = false;

  constructor(
    private acmicService: AcmicService
  ) { }

  ngOnInit() {
    
      this.isAcmic = this.acmicService.isACMIC();
    
    
  }

}
